  <!-- components/admin/employees.vue -->
<template>
  <div class="app-container">
    <!-- 搜索条件区域 -->
    <el-card class="filter-container" shadow="never">
      <div style="margin-top: 20px">
        <el-form :inline="true" :model="listQuery" size="small" label-width="140px">
          <el-form-item label="输入搜索：">
            <el-input v-model="listQuery.keyword" placeholder="员工姓名/手机号" clearable></el-input>
          </el-form-item>       
          <!-- el-form-item label="状态：">
            <el-select v-model="listQuery.status" placeholder="全部" clearable>
              <el-option label="启用" value="ACTIVE"></el-option>
              <el-option label="禁用" value="INACTIVE"></el-option>
            </el-select>
          </el-form-item -->
                  <el-button type="primary" @click="handleSearchList" size="small">
          查询
        </el-button>
        <el-button  @click="handleResetSearch" size="small">
          重置
        </el-button>
        </el-form>
        
      </div>
    </el-card>


    <!-- 表格区域 -->
    <div class="table-container">
      <el-table
        ref="employeeTable"
        :data="loglist"
        style="width: 800px; margin: 0 auto 0 auto;"
        v-loading="listLoading"        
        border
        stripe
        @selection-change="handleSelectionChange">        

        <el-table-column prop="operation_content" label="操作内容" width="445" align="center"></el-table-column>
        
        <el-table-column prop="operator" label="操作用户" width="150" align="center"></el-table-column>
        
        <el-table-column prop="operation_time" label="操作时间" width="200" align="center">
<template slot-scope="scope">
            {{ formatTime(scope.row.operation_time) }}
          </template>

        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="listQuery.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="listQuery.pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {listLogs } from "@/api/tenant/operationlog";
import { formatToBeijingTime } from '@/util/date';

export default {
  name: "AdminOperationLog",
/**  props: {
    tenantId: {
      type: Number,
      required: true
    }
  },**/
  data() {
    // 手机号校验规则
    const phoneValidator = (rule, value, callback) => {
      if (rule.required && !value) {
        callback(new Error("手机号不能为空"));
      } else {
        callback();
      }
    };

    return {
      // 表格数据
      loglist: [],
      total: 0,
      listLoading: false,
      multipleSelection: [],
      
      // 搜索条件
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        keyword: '',        
        status: ''
      },
      
      // 部门选项（从接口获取）
      deptOptions: [],
      
      // 弹窗相关
      dialogVisible: false,
      dialogTitle: '',
      form: {
        Id: null,        // 员工ID，null表示添加，>0表示编辑
        realName: "",
        phone: "",
        email: ""
      },
      rules: {
        realName: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        phone: [
          { 
            required: false,
            validator: phoneValidator,
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
        ...mapState('auth', ['tenantInfo', 'userInfo','loginType']),
    tenantInfo() {
      return this.$store.getters['auth/currentTenant'];
    },
    tenantId() {
      return this.tenantInfo?.tenantId || null;
    },    
    // 判断是否为编辑模式
    isEdit() {
      return this.form.Id !== null && this.form.Id > 0;
    }
  },
  watch: {
    // 监听 isEdit 变化，动态更新手机号校验规则
    isEdit(val) {
      const phoneRule = this.rules.phone[0];
      if (val) {
        phoneRule.required = false;
      } else {
        phoneRule.required = true;
      }
    }
  },
  created() {
    console.log("this.userInfo", this.userInfo);
    console.log("tenantInfo", this.tenantInfo);
    if( this.userInfo.username!=  this.tenantInfo.adminUsername){
               this.$message.error("没有权限");
                       this.$router.push('/employee/workspace')
               //return;
    }
   this.getList();

  },
  methods: {

      formatTime(time) {
    if (!time) return '-'
    return formatToBeijingTime(time)
  },  
    // ==================== 表格数据 ====================
    
    /** 获取员工列表 */
    getList() {
      console.log(" getList()", this.listQuery)
      this.listLoading = true;
      listLogs(this.tenantId, this.listQuery.keyword).then(response => {
        console.log("listLogs response", response)
              console.log("listLogs response.data", response.data)
        if(response.code===200){
        this.loglist = response.data.records;
        this.total = response.data.total;
        this.listLoading = false;
      } else{
         this.$message.error(response.data.message);
      }
      }).catch(() => {
        this.listLoading = false;
      });
    },

    /** 获取部门选项 */
    getDeptOptions() {
      // 调用部门接口获取选项
      // getDeptList(this.tenantId).then(response => {
      //   this.deptOptions = response.data;
      // });
    },

    /** 刷新表格 */
    handleRefresh() {
      this.getList();
    },

    /** 搜索 */
    handleSearchList() {
      this.listQuery.pageNum = 1;
      this.getList();
    },

    /** 重置搜索 */
    handleResetSearch() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 10,
        keyword: '',        
        status: ''
      };
      this.getList();
    },

    /** 多选 */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /** 分页大小变化 */
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },

    /** 页码变化 */
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList();
    },
  }
};
</script>

<style scoped>
.app-container {
  padding: 16px;
}

.filter-container {
  padding-left: 100px;
  margin-bottom: 16px;
}

.operate-container {
  margin-bottom: 16px;
}

.table-container {
  margin-bottom: 16px;
  text-align: center;
  width: 100%;
  display: block;
  padding:   0 auto 0 auto;
}

.pagination-container {
  text-align: center;
  margin-top: 16px;
}

.btn-add {
  background-color: #409eff;
  color: white;
}

/* 只读输入框视觉优化 */
.readonly-input ::v-deep .el-input__inner {
  background-color: #f5f7fa;
  color: #909399;
  cursor: not-allowed;
}

/* 提示文字样式 */
.tip-text {
  font-size: 11px;
  color: #909399;
  margin-top: 4px;
  line-height: 1.4;
}

.tip-text i {
  margin-right: 3px;
}
</style>